import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { GroupCreatePage } from '@/features/access/groups/group-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

export const Route = createFileRoute('/$tenant/groups/new')({ component: NewGroupRoute });

function NewGroupRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="members"
      crumbs={[{ label: t('access.groups.title') }, { label: t('access.groups.newTitle') }]}
    >
      <GroupCreatePage tenantId={tenant} />
    </ConsoleShell>
  );
}
